const lookUpZip = async (zip: string): Promise<any[]> => {
  const response = await fetch(lookUpZipPath(zip));
  if (!response.ok) {
    throw new Error('Invalid ZIP code');
  }
  const data = await response.json();
  if (data.status !== 'OK') {
    throw new Error('Invalid ZIP code');
  }
  console.log(data.results);

  return data.results;
};

const lookUpZipPath = (zip: string): string => {
  const base = new URL(`https://maps.googleapis.com/maps/api/geocode/json`);
  base.searchParams.append('address', zip);
  base.searchParams.append('key', process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '');
  return base.toString();
};

export default lookUpZip;
